<div class="w-full overflow-x-scroll shadow-md">
  <table class="shadow-md">
    <tr>
      <th class="bg-orange">Group License</th>
      <th class="bg-blue">Individual Subscriptions</th>
      <th class="bg-green">Testing-Only License</th>
      <th class="bg-gray">Free</th>
    </tr>
    <tr class="text-gray text-center">
      <td class="bg-orange-50 text-orange-50-900">All of uTheory at no cost to students</td>
      <td class="bg-blue-50 text-blue-800">All of uTheory at no cost to schools</td>
      <td class="bg-green-50 text-green-800">Ideal for placement testing</td>
      <td class="bg-gray-75 text-gray-900">Limited features for occasional use</td>
    </tr>
    <tr class="text-gray">
      <td>
        <h3>Students:</h3>
        <ul>
          <li>Unlimited lessons and practice</li>
          <li>Unlimited tests and test attempts</li>
          <li>Free to students</li>
        </ul>
      </td>
      <td>
        <h3>Students:</h3>
        <ul>
          <li>Unlimited lessons and practice</li>
          <li>Unlimited tests and test attempts</li>
          <li>Students pay $5.99/month or $39.99/year<sup>**</sup></li>
        </ul>
      </td>
      <td>
        <h3>Students:</h3>
        <ul>
          <li>Limited lessons and practice<sup>*</sup></li>
          <li>Unlimited tests and test attempts</li>
          <li>Free to students</li>
        </ul>
      </td>
      <td>
        <h3>Students:</h3>
        <ul>
          <li>Limited lessons and practice<sup>*</sup></li>
          <li>Free to students</li>
        </ul>
      </td>
    </tr>
    <tr class="text-gray">
      <td>
        <h3>Teachers:</h3>
        <ul>
          <li>Assign lessons and practice</li>
          <li>Track student progress</li>
          <li>Create multiple custom tests</li>
          <li>
            <a href="#pricing-calculator" class="text-cyan font-semibold"
              >Pricing from $10.00 to $3.00 per student</a
            >
          </li>
        </ul>
      </td>
      <td>
        <h3>Teachers:</h3>
        <ul>
          <li>Assign lessons and practice</li>
          <li>Track student progress</li>
          <li>Create multiple custom tests</li>
          <li>Free to schools</li>
        </ul>
      </td>
      <td>
        <h3>Teachers:</h3>
        <ul>
          <li>Assign lessons and practice</li>
          <li>Track student progress</li>
          <li>Create multiple custom tests</li>
          <li>
            <a href="#pricing-calculator" class="text-cyan font-semibold"
              >Pricing starts at $1.50 per student</a
            >
          </li>
        </ul>
      </td>
      <td>
        <h3>Teachers:</h3>
        <ul>
          <li>Assign lessons and practice</li>
          <li>Track student progress</li>
          <li>No custom testing features</li>
          <li>Free to schools</li>
        </ul>
      </td>
    </tr>
  </table>
</div>
<div class="text-center text-gray mt-6 max-w-xl mx-auto px-4">
  <p class="text-base">
    <sup>*</sup>Currently limited to 10 pages of a lesson or practice exercise
  </p>
  <p class="text-base mt-2">
    <sup>**</sup>Discounted access packs for sale at bookstores are available upon request
  </p>
  <p class="text-2xl mt-4">
    Check out these <a
      class="text-cyan underline font-semibold"
      rel="external"
      href="https://info.utheory.com/introducing-group-licenses-73e5915e4ba4/"
      >frequently asked questions</a
    >
    or
    <a
      class="text-cyan underline font-semibold"
      rel="external"
      href="/teach/pdfs/utheory-purchasing-guide.pdf"
      >download our license purchasing guide
    </a> to learn more.
  </p>
</div>

<style lang="postcss">
  table {
    border-collapse: collapse;
    min-width: 900px;
  }

  tr:last-child > td {
    @apply pb-12;
  }

  th {
    @apply h-20 text-white text-3xl;
  }

  th:not(:last-child),
  td:not(:last-child) {
    @apply border-r-2 border-gray-light;
  }

  th,
  td {
    /* @apply w-1/4; */
    @apply w-1/4 py-2 px-3;
  }

  tr:nth-child(3) > td,
  tr:nth-child(4) > td {
    @apply pl-3 pr-1 pt-3;
    vertical-align: top;
    line-height: 30px;
  }

  h3 {
    @apply font-semibold mt-2;
  }

  ul {
    @apply text-base list-disc ml-4;
  }

  li {
    @apply mt-3;
  }

  td {
    border-spacing: 80px;
  }
</style>
